<template>
  <div class="container">
    <div class="contentChild">
      <div class="childLeft">
        <div class="titleText">中物供应链物流信息平台</div>
        <img src="../../../assets/images/new_leftImg.png" class="leftImg"/>
      </div>
      <div class="childRight">
        <div class="Rcont">
          <div class="top">
            欢迎登录
            <p class="xian"><span></span></p>
          </div>
          <div class="bottom">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules"  >
              <div style="margin-bottom:60px">
                  <el-form-item prop="username">
                  <el-input
                    v-model="loginForm.username"
                    maxlength="20"
                    placeholder="请输入用户名"
                  ></el-input>
                  <i class="fa fa-user-o" aria-hidden="true"></i>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    v-model="loginForm.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                  <i class="fa el-icon-lock" ></i>
                </el-form-item>
                <el-form-item prop="validCode" class="codeItem">
                  <el-input
                    v-model="loginForm.validCode"
                    maxlength="5"
                    placeholder="请输入验证码"
                    style="width:236px;margin-right:10px"
                  ></el-input>
                    <i class="fa el-icon-set-up" ></i>
                  <div class="coderight">
                    <img :src="codeImg" @click="getYzm()" class="login-code-img" />
                    <!-- <s-identify :identifyCode="identifyCode"></s-identify> -->
                  </div>
                </el-form-item>
              </div>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="login()"
                  v-on:keyup.13.native="submit"
                  class="bigBtn"
                  style="width:100%;background-color: #0c46a2;"
                  >登 录</el-button
                >
                <div class="card-foot">
                <!-- <span @click="registerGo">注册</span> -->
                <span @click="forgetPassword">忘记密码</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      技术支持：中物（北京）物流信息服务有限公司 &nbsp;&nbsp;| &nbsp;&nbsp;联系电话：010-59693540  &nbsp;&nbsp; | &nbsp;&nbsp; 联系地址：北京市朝阳区百子湾西里402号楼9层909 &nbsp;&nbsp; | &nbsp;&nbsp; 京ICP备15044580号-1
    </div>
    <!--是否发送短信弹框 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="550px"
      center
    >
      <span>
        <el-form
          :model="isSendMessageFrom"
          ref="isSendMessageFrom"
          class="demo-form-inline"
          label-width="148px"
          size="mini"
        >
          <div class="addinpBox">
            <el-form-item label="验证码:" prop="name">
              <el-input
                placeholder="请输入验证码"
                maxlength="10"
                v-model.trim="isSendMessageFrom.name"
                style="width:150px;"
              ></el-input
              >&nbsp;&nbsp;&nbsp;
              <span
                v-if="isShowGetCode"
                class="identiCode"
                @click="getIdentifyCode"
                >获取验证码</span
              >
              <span v-else class="identiCode cancel-pointer"
                >{{ countdown }}s后可重试</span
              >
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="saveFn()"
          :loading="isSendMessageLoad"
          >提交短信验证码</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { encryption } from '@/utils/util'
// eslint-disable-next-line no-unused-vars
import { loginUser, isCheck, loginUserV2 } from '@/api/common'
import store from '@/store'
export default {
  data () {
    return {
      // 是否发送短信
      title: '发送短信',
      dialogVisible: false,
      // isSendMessageFrom: {},
      isSendMessageLoad: false,
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      // 表单数据对象
      loginForm: {
        grant_type: 'password',
        username: '',
        password: '',
        validCode: '',
        deviceId: ''
      },
      codeImg: '',
      // 校验规则对象
      loginRules: {
        // 定义字段对应的校验规则(多种)
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        validCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      taken: '', // 获取token
      access_token: '', // 获取access_token
      menuDataList: [], // 用户菜单列表
      tel: '',
      smsCode: '', // 短信验证码
      isCutCrm3: null,
      baseUrl: null,
      // eslint-disable-next-line vue/no-dupe-keys
      // eslint-disable-next-line no-dupe-keys
      isSendMessageFrom: {
        name: ''
      }
    }
  },
  mounted () {
    document.title = '登录'
  },
  methods: {
    loginV2 () {
      this.$router.push({ path: '/NoLoginLoginV2' })
    },
    // 验证码
    getLoginCode () {
      let url = this.global.commonName + '/validata/code'
      let randomLenNum = this.randomLenNum(4, true)
      this.loginForm.deviceId = randomLenNum
      this.codeImg = url + '?deviceId=' + randomLenNum
    },
    getYzm () {
      this.getLoginCode()
    },

    // 随机数
    randomLenNum (len, date) {
      let random = ''
      random = Math.ceil(Math.random() * 100000000000000)
        .toString()
        .substr(0, len || 4)
      if (date) random = random + Date.now()
      return random
    },
    submit () {
      this.login()
    },
    // 点击登录
    login () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          let data = encryption({
            data: this.loginForm,
            key: this.global.key,
            param: ['password']
          })
          let Authorization1 = encryption({
            data: { Basic: this.global.headerBasic },
            type: 'Base64',
            param: ['Basic']
          })
          const loading = this.$loading({
            lock: true,
            text: '正在登录...'
          })
          this.$axios({
            headers: {
              Authorization: 'Basic ' + Authorization1.Basic
            },
            method: 'post',
            url: this.global.commonNameV2 + '/oauth/token',
            params: data
          })
            .then(res => {
              loading.close()
              this.taken = res.data
              this.access_token = res.data.access_token
              this.isCutCrm3 = res.data.isCutCrm3
              localStorage.setItem('isCutCrm3', res.data.isCutCrm3)
              if (this.isCutCrm3 == 1) { // 0否，1是
                this.baseUrl = this.global.commonNameV2
              } else {
                this.baseUrl = this.global.commonName
              }
              this.$axios({
                headers: {
                  Authorization: 'Bearer ' + this.access_token
                },
                method: 'get',
                url: this.baseUrl + '/user/isCheckSMS'
                // params: data
              })
                .then(res => {
                  let secondheckFlg = res.data.secondheckFlg
                  this.tel = res.data.mobile
                  if (secondheckFlg == '0') {
                    // 等于0不进行短信验证，直接登录
                    store.setUser(this.taken)
                    if (this.isCutCrm3 == 1) { // 0否，1是
                      this.getLoginUserV2()
                    } else {
                      this.getLoginUser()
                    }
                  } else {
                    // 验证短信
                    this.dialogVisible = true
                  }
                })
                .catch(error => {
                  this.$message.error(error.message)
                })
            })
            .catch(error => {
              loading.close()
              this.getYzm()
              this.$message.error(error.message)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取用户信息
    getLoginUser () {
      loginUser().then(res => {
        // 判断是否跳转认证信息页面
        // let menuList = res.menuList
        // let menuList = res.allowList[0].menuTree[0]
        this.$axios({
          headers: {
            Authorization: 'Bearer ' + this.access_token
          },
          method: 'post',
          url: this.global.crm + '/registerInfo/checkAndSkip',
          data: {}
        })
          .then(response => {
            if (response.data.flag == false) {
              // 等于false,需要认证
              this.$router.push({ path: '/common/authentication' })
              localStorage.setItem('businessFlg', response.data.type)
              localStorage.setItem('registerId', res.userId)
              // store.setUser(this.taken)
            } else {
              // this.$router.push({ path: menuList.menufuncIp })
              if (res.menuList != 0) {
                localStorage.setItem('mobile', res.mobile)
                localStorage.setItem('userCode', res.userCode)
                localStorage.setItem('userName', res.userName)
                localStorage.setItem('tenantName', res.tenantName)
                localStorage.setItem('tenantCode', res.tenantCode)
                localStorage.setItem('registerId', res.userId)
                localStorage.setItem('businessFlg', res.businessFlg)
                localStorage.setItem('tenantTaxpayerNumber', res.tenantTaxpayerNumber)
                localStorage.setItem('isAdmin', res.isAdmin)
                if (res.menuList[0].childMenu == 0) {
                  store.setIp(res.menuList[0].menufuncIp)
                  this.$router.push({ path: res.menuList[0].menufuncIp })
                } else {
                  store.setIp(res.menuList[0].childMenu[0].menufuncIp)
                  this.$router.push({
                    path: res.menuList[0].childMenu[0].menufuncIp
                  })
                }
                this.menuDataList = res.menuList
                this.menuDataList.forEach((item, index) => {
                  if (item.childMenu.length == 0) {
                    localStorage.setItem(item.menufuncIp, JSON.stringify(item.buttonList))
                  } else {
                    item.childMenu.forEach((item1, index) => {
                      localStorage.setItem(item1.menufuncIp, JSON.stringify(item1.buttonList))
                    })
                  }
                })
              } else {
                this.$message.error('该账号没有菜单权限！')
                this.logout()
              }
            }
          })
          .catch(error => {
            this.$message.error(error.message)
          })
      })
    },
    // 获取用户信息
    getLoginUserV2 () {
      loginUserV2().then(res => {
        // 判断是否跳转认证信息页面
        // let menuList = res.menuList
        // let menuList = res.allowList[0].menuTree[0]
        localStorage.setItem('registerId', res.userId)
        localStorage.setItem('mobile', res.mobile)
        localStorage.setItem('userCode', res.userCode)
        localStorage.setItem('userName', res.userName)
        localStorage.setItem('tenantName', res.tenantName)
        localStorage.setItem('tenantCode', res.tenantCode)
        localStorage.setItem('registerId', res.userId)
        localStorage.setItem('businessFlg', res.businessFlg)
        localStorage.setItem('tenantTaxpayerNumber', res.tenantTaxpayerNumber)
        localStorage.setItem('userType', res.userType)
        localStorage.setItem('isAdmin', res.isAdmin)
        localStorage.setItem('orgName', res.orgName)
        localStorage.setItem('orgCode', res.orgCode)
        localStorage.setItem('dataLevel', res.dataLevel)
        localStorage.setItem('companyName', res.companyName)
        localStorage.setItem('companyCode', res.companyCode)
        localStorage.setItem('orgSubCode', res.orgSubCode)
        localStorage.setItem('orgSubName', res.orgSubName)
        if (res.businessList) {
          res.businessList.forEach(item => {
            res.tenantList.push({ tenantCode: item.businessId, businessCode: item.businessCode, tenantName: item.businessName, flag: true })
          })
        }
        if (res.tenantList.length == 1) {
          localStorage.setItem('isBusiness', res.businessList && res.businessList.length == 1 ? 1 : 2)
          localStorage.setItem('createTenantCode', res.tenantList[0].tenantCode)
          localStorage.setItem('createTenantName', res.tenantList[0].tenantName)
          this.$router.push({ path: '/' })
        } else if (res.tenantList.length > 1) {
          localStorage.setItem('tenantList', JSON.stringify(res.tenantList))
          this.$router.push({ path: '/selectOrg' })
        } else {
          this.$message.error('该账号无操作权限！')
          this.logout()
        }
        // this.$axios({
        //   headers: {
        //     Authorization: 'Bearer ' + this.access_token

        //   },
        //   method: 'post',
        //   url: this.global.crm + '/registerInfo/checkAndSkip',
        //   data: {}
        // })
        //   .then(response => {
        //     if (response.data.flag == false) {
        //       // 等于false,需要认证
        //       this.$router.push({ path: '/common/authentication' })
        //       localStorage.setItem('businessFlg', response.data.type)

        //       // store.setUser(this.taken)
        //     } else {
        //       // this.$router.push({ path: menuList.menufuncIp })
        //       if (res.menuList != 0) {

        //         // if (res.menuList[0].childMenu == 0) {
        //         //   store.setIp(res.menuList[0].menufuncIp)
        //         //   this.$router.push({ path: res.menuList[0].menufuncIp })
        //         // } else {
        //         //   if (res.menuList[0].childMenu.childMenu == 0) {
        //         //     store.setIp(res.menuList[0].childMenu.menufuncIp)
        //         //     this.$router.push({ path: res.menuList[0].childMenu.menufuncIp })
        //         //   } else {
        //         //     store.setIp(res.menuList[0].childMenu[0].childMenu[0].menufuncIp)
        //         //     this.$router.push({
        //         //       path: res.menuList[0].childMenu[0].childMenu[0].menufuncIp
        //         //     })
        //         //   }
        //         //   store.setIp(res.menuList[0].childMenu[0].childMenu[0].menufuncIp)
        //         //   this.$router.push({
        //         //     path: res.menuList[0].childMenu[0].childMenu[0].menufuncIp
        //         //   })
        //         // }
        //         // this.menuDataList = res.menuList
        //         // this.menuDataList.forEach((item, index) => {
        //         //   if (item.childMenu.length == 0) {
        //         //     localStorage.setItem(item.menufuncIp, JSON.stringify(item.buttonList))
        //         //   } else {
        //         //     item.childMenu.forEach((item1, index) => {
        //         //       localStorage.setItem(item1.menufuncIp, JSON.stringify(item1.buttonList))
        //         //     })
        //         //   }
        //         // })
        //       } else {
        //         this.$message.error('该账号没有菜单权限！')
        //       }
        //     }
        //   })
        //   .catch(error => {
        //     this.$message.error(error.message)
        //   })
      })
    },
    // 退出登录
    logout () {
      this.$axios
        .get(this.global.commonName + '/oauth/remove/token')
        .then(res => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 点击是否发送短信确定按钮
    saveFn () {
      this.$axios({
        headers: {
          Authorization: 'Bearer ' + this.access_token
        },
        method: 'get',
        url: this.baseUrl + '/user/checkSMS',
        params: {
          mobile: this.tel,
          smsCode: this.isSendMessageFrom.name
        }
      })
        .then(res => {
          store.setUser(this.taken)
          this.$message.success('短信验证成功！')
          if (this.isCutCrm3 == 1) { // 0否，1是
            this.getLoginUserV2()
          } else {
            this.getLoginUser()
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(error.message)
        })
    },
    // 点击获取验证码
    getIdentifyCode () {
      this.countDown()
      this.isShowGetCode = false
      this.$axios({
        headers: {
          Authorization: 'Bearer ' + this.access_token
        },
        method: 'get',
        url: this.global.commonName + '/user/sendSMS',
        params: {
          mobile: this.tel
        }
      })
        .then(res => {
          // this.smsCode = res.data.smsCode
        })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 注册
    registerGo () {
      this.$router.push('/common/register')
    },
    // 忘记密码
    forgetPassword () {
      this.$router.push('/common/forgetPass')
    }
  },
  created () {
    // 点击空格-登录
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.submit()
      }
    }
    this.getLoginCode()
  }
}
</script>

<style scoped lang="less">

.container{
  width: 100%;
  height: 100vh;
  min-width: 990px;
  min-height: 500px;
  background: url('../../../assets/images/newBJImg.jpg') no-repeat center center / cover;
  display: flex;
  position: relative; /* 添加相对定位 */
}
.contentChild{
  width: 60%;
  height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: space-between;
}
.childLeft{
  .titleText{
    text-align: center;
    color: #0c46a2;
    font-size: 30px;
    font-weight: 600;
    margin: 20px 0;
  }
  .leftImg{
    width: 100%; /* 根据图片实际大小 */
    height: 70%;
    margin-top: 10px;
  }
}
.childRight {
  width: 32%; /* 保持宽度 */
  height: 70%;
  background-color: rgba(255, 255, 255, 0.95); /* 添加半透明白色背景 */
  padding: 30px 20px; /* 添加内边距 */
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1); /* 添加阴影增强立体感 */
  z-index: 2; /* 确保在最上层 */
  border-radius: 8px;
  margin-top: 20px;
}
.Rcont {
  width: 100%; /* 改为100%填充右侧容器 */
  .top {
    text-align: center;
    color: #333333;
    font-size: 22px;
    // border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    position: relative;
    margin-bottom: 50px;

    .xian {
      position: absolute;
      bottom: -4px;
      text-align: center;
      width: 100%;
      height: 3px;

      span {
        display: inline-block;
        width: 60px;
        height: 3px;
        background-color: #0c46a2;
      }
    }
  }
}
.footer {
  position: fixed;
  bottom: 18px;
  width: 100%;
  font-size: 12px;
  color: #0c46a2;
  text-align: center;
  z-index: 3; /* 确保在最上层 */
}
/deep/ .el-input__inner {
  box-shadow: inset 0 0 0 1000px #ffffff !important;
  border: none;
  border-bottom: 1px solid #cccccc;
  padding-left: 28px;
}
/deep/ .el-form-item__content {
  position: relative;

  .fa {
    position: absolute;
    left: 6px;
    bottom: 8px;
    font-size: 18px;
    color: #0c46a2;
  }
}
.codeItem {
  position: relative;
  height: 40px;

  .codeInput {
    position: absolute;
    top: 0;
    left: 0;
    width: 62%;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    padding: 0;
  }

  .coderight {
    position: absolute;
    top: 0;
    right: 0px;
    cursor: pointer;

    img {
      width: 120px;
      height: 40px;
    }
  }
}
</style>
